export default __webpack_public_path__ + "static/media/pinBlock.de92a037.png";